export const THEMES = [
  { id: "paper", label: "Paper", bg: "#FBF7EF", text: "#1F2937", sub: "#7C6F5E", line: "#E9DFCF", night: false },
  { id: "sepia", label: "Sepia", bg: "#F3E4C8", text: "#3B2A1A", sub: "#8A6A47", line: "#E2CDA6", night: false },
  { id: "sage", label: "Sage", bg: "#E7EEE2", text: "#1F2E25", sub: "#5E7564", line: "#CFDCC7", night: false },
  { id: "sky", label: "Sky", bg: "#E8EFF6", text: "#16263A", sub: "#5B7088", line: "#CCD9E6", night: false },
  { id: "night", label: "Night", bg: "#0E1626", text: "#E9DFC9", sub: "#8F9AB0", line: "#223047", night: true },
];

export const MARKS: Record<string, { day: string; night: string; dot: string; label: string }> = {
  gold: { day: "#FDE68A", night: "rgba(253,230,138,0.24)", dot: "#F2C94C", label: "Gold" },
  rose: { day: "#FBCFE8", night: "rgba(244,114,182,0.24)", dot: "#EC8FB8", label: "Rose" },
  sky: { day: "#BAE6FD", night: "rgba(56,189,248,0.24)", dot: "#5BB8E8", label: "Sky" },
  sage: { day: "#BBF7D0", night: "rgba(74,222,128,0.22)", dot: "#5FC98A", label: "Sage" },
  lavender: { day: "#DDD6FE", night: "rgba(167,139,250,0.26)", dot: "#9C8CF0", label: "Lavender" },
};

export type ReaderPrefs = { theme: string; dayTheme: string; size: number };

export const loadPrefs = (): ReaderPrefs => ({ theme: "paper", dayTheme: "paper", size: 20, ...JSON.parse(localStorage.getItem("cast_deep_prefs") || "{}") });
export const savePrefs = (p: ReaderPrefs) => localStorage.setItem("cast_deep_prefs", JSON.stringify(p));
export const themeOf = (id: string) => THEMES.find((t) => t.id === id) || THEMES[0];

export async function streamSSE(url: string, body: any, onEvent: (ev: any) => void) {
  const res = await fetch(url, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok || !res.body) {
    const d = await res.json().catch(() => ({}));
    onEvent({ t: "error", message: typeof d.detail === "string" ? d.detail : "Something went wrong. Please try again." });
    return;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop() || "";
    for (const p of parts) {
      try { onEvent(JSON.parse(p.replace(/^data: /, ""))); } catch { /* partial chunk */ }
    }
  }
}
